import { Component, input, signal } from '@angular/core';
import { AutomationIdDirective } from '@innogy/utils-automation-id';
import {
  TrackInteractionDirective,
  TrackLinkDirective,
} from '@analytics/events';
import { CrntButton, CrntIcon } from '@essent/current-web-angular';

import { FeedBackSettings } from '../models/feedback.model';

export enum AnswerType {
  None,
  Affirmed,
  Denied,
}

@Component({
  selector: 'wl-accordion-feedback',
  templateUrl: './feedback.component.html',
  styleUrls: [
    './feedback.component.ed.scss',
    './feedback.component.essent.scss',
  ],
  standalone: true,
  imports: [
    AutomationIdDirective,
    TrackInteractionDirective,
    CrntButton,
    CrntIcon,
    TrackLinkDirective,
  ],
})
export class FeedbackComponent {
  readonly question = input.required<string>();
  readonly feedbackSettings = input.required<FeedBackSettings>();

  affirmativeText = 'Ja';
  denyingText = 'Nee';

  readonly answer = signal(AnswerType.None);
  protected readonly AnswerType = AnswerType;

  onAnswer(answerType: AnswerType) {
    this.answer.set(answerType);
  }
}
